
import Vue from "vue";
import RvsStatusByEquipment from "./overallStatus/RvsStatusByEquipment.vue";
import McaStatusByEquipment from "./overallStatus/McaStatusByEquipment.vue";

const ORDER_STORAGE_KEY = "overall.cardOrder";
const DEFAULT_CARD_ORDER = ["mca", "rvs"];
const CARD_COMPONENTS = { mca: "McaStatusByEquipment", rvs: "RvsStatusByEquipment" };

export default Vue.extend({
  name: "ModelOverall",
  components: { RvsStatusByEquipment, McaStatusByEquipment },
  data() {
    const datas = [
      {
        tagName: "test001",
        values: 20.5,
      },
      {
        tagName: "test002",
        values: 20.5,
      },
    ];
    const datasVca = [
      {
        tagName: "VCA001",
        values: 20.5,
      },
      {
        tagName: "VCA002",
        values: 20.5,
      },
    ];
    const fetchDatas = [];
    const headers = [
      { text: "TAG NAME", value: "tagName", sortable: false },
      { text: "VALUES", value: "values", sortable: false },
    ];
    return {
      datas,
      datasVca,
      headers,
      fetchDatas,
      checkComponents: false,
      count: 0,
      cardComponents: CARD_COMPONENTS,
      cardOrder: [...DEFAULT_CARD_ORDER] as string[],
      draggingKey: null as string | null,
      dragOverKey: null as string | null,
      dragArmedKey: null as string | null,
    };
  },
  created() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(ORDER_STORAGE_KEY) || "null");
      const isValid =
        Array.isArray(stored) &&
        stored.length === DEFAULT_CARD_ORDER.length &&
        DEFAULT_CARD_ORDER.every((key) => stored.includes(key));
      if (isValid) this.cardOrder = stored;
    } catch {
      /* invalid or unavailable localStorage -- keep default order */
    }
  },
  mounted() {
    window.addEventListener("mouseup", this.disarmDrag);
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.disarmDrag);
  },
  computed: {
    companyId() {
      return this.$store.state.company.id;
    },
  },
  // async created() {
  //   this.fetchDatas = await this.fetchOverallModel();
  // },
  methods: {
    checkTypeExist(type: string) {
      return this.fetchDatas.filter((val) => val.model_type === type).length > 0;
    },
    disarmDrag() {
      if (!this.draggingKey) this.dragArmedKey = null;
    },
    onDragStart(key: string, e: DragEvent) {
      this.draggingKey = key;
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", key);
      }
    },
    onDrop(targetKey: string) {
      const fromKey = this.draggingKey;
      if (!fromKey || fromKey === targetKey) return;
      const order = this.cardOrder.filter((key) => key !== fromKey);
      order.splice(this.cardOrder.indexOf(targetKey), 0, fromKey);
      this.cardOrder = order;
      this.saveOrder();
    },
    onDragEnd() {
      this.draggingKey = null;
      this.dragOverKey = null;
      this.dragArmedKey = null;
    },
    saveOrder() {
      try {
        window.localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify(this.cardOrder));
      } catch {
        /* localStorage unavailable -- ignore */
      }
    },
  },
  // watch: {
  //   async companyId() {
  //     this.fetchDatas = await this.fetchOverallModel();
  //   },
  // },
});
